import { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import { QRCodeSVG } from "qrcode.react";
import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { OtpInputField } from "components/Auth/shared/OtpInputField";
import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import AuthContext from "context/auth/authContext";
import { body1Bold, body2SemiBold } from "shared";

import { SendOtpCodeToEnableProps } from "../types";

const SendOtpCodeToEnable = ({
    secretKey,
    error,
    isLoading,
    changeCode
}: SendOtpCodeToEnableProps) => {
    const { gray900 } = colors;

    const { user } = useContext(AuthContext);

    const { t } = useTranslation();

    const [isQr, setIsQr] = useState(true);

    const toggleIsQr = () => setIsQr(!isQr);

    return (
        <div
            css={css({
                color: gray900
            })}
        >
            <div css={[body2SemiBold, { marginBottom: "16px" }]}>
                {isQr
                    ? t("Security##2FA##send otp code##scan QR code")
                    : t("Security##2FA##send otp code##type text code")}
                :
            </div>

            {isQr ? (
                <QRCodeSVG
                    size={144}
                    fgColor={gray900}
                    value={`otpauth://totp/${import.meta.env.VITE_2FA_NAME}:${user?.email}?secret=${secretKey}&issuer=${import.meta.env.VITE_2FA_NAME}`}
                />
            ) : (
                <div css={body1Bold}>{secretKey}</div>
            )}

            <TextLink
                size={TEXT_LINK_SIZES.Normal}
                onClick={toggleIsQr}
                css={css({
                    margin: "16px 0 24px 0"
                })}
            >
                {isQr
                    ? t("Security##2FA##send otp code##click to type code")
                    : t("Security##2FA##send otp code##click to scan code")}
                .
            </TextLink>

            <OtpInputField
                isLoading={isLoading}
                error={error}
                onChange={changeCode}
                isRequired
            />
        </div>
    );
};

export { SendOtpCodeToEnable };
